import React, { Fragment } from 'react'

import Days from './Days/Days'
import WeekDays from './WeekDays/WeekDays'
import MonthTitle from './MonthTitle/MonthTitle'

import s from './MonthView.scss'


const MonthView = (props) => {
  const {
    year, month, days, selectedDates, isPrevArrowVisible, backgrounds, gutter,
    goPrevMonth, goNextMonth, onDayClick, onWeekDayClick,
  } = props

  return (
    <Fragment>
      <MonthTitle
        month={month}
        year={year}
        gutter={gutter}
        isPrevArrowVisible={isPrevArrowVisible}
        goPrevMonth={goPrevMonth}
        goNextMonth={goNextMonth}
      />
      <WeekDays
        gutter={gutter}
        onWeekDayClick={onWeekDayClick}
      />
      <Days
        days={days}
        year={year}
        month={month}
        gutter={gutter}
        backgrounds={backgrounds}
        selectedDates={selectedDates}
        onDayClick={onDayClick}
      />
    </Fragment>
  )
}


export default MonthView
